import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import formValidation from "../../validations/es6/core/Core";
import Datetime from "react-datetime";
import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  Button,
  Alert,
  Form,
  FormText,
  Input,
} from "reactstrap";
import Select from "react-select";
import { createValidationOptions } from "./subUsersAddValidation";
import ModalConfirm from "../../components/modalConfirm";
import { useTranslation } from "react-i18next";
import Countries from "../../utils/countriesExtended.json"

import 'react-datetime/css/react-datetime.css';

require('moment/locale/en-gb');

const SubUsersAdd = () => {
  const { t, i18n } = useTranslation();
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  const [redirect, setRedirect] = useState(false);

  const [country, setCountry] = useState(false);

  const [lang, setLang] = useState(i18n.language);
  const [opt, setOpt] = useState(createValidationOptions(lang));

  let afterOneYear = Datetime.moment().add(1, 'years');
  let validDate = function (current) {
    return current.isAfter(afterOneYear);
  };
  const [contractExpiryDate, setContractExpiryDate] = useState(afterOneYear);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    setOpt(createValidationOptions(lang));
  }, [lang]);

  useEffect(() => {
    var formID = document.getElementById("addNewSubUser");
    const fv =formValidation(formID, opt)
    fv.on("core.element.validated", function(e) {
      if (e.valid) {
        const messages = [].slice.call(formID.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
        messages.forEach((messageEle) => {
            messageEle.style.display = 'none';
        });
        return;
      }
    })
    .on("core.validator.validated", function(e) {
      if (!e.result.valid) {
        const messages = [].slice.call(formID.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
        for(let i = 0; i < messages.length - 1; i++) {
          const messageEle = messages[i];
          messageEle.style.display = 'none';
        }
      }
    })
    .on("core.form.valid", e => {
      let formData = new FormData();

      formData.append("first_name", formID.querySelector('[name="first_name"]').value);
      formData.append("last_name", formID.querySelector('[name="last_name"]').value);
      formData.append("email", formID.querySelector('[name="email"]').value);
      formData.append("username", formID.querySelector('[name="username"]').value);
      formData.append("password", formID.querySelector('[name="password"]').value);
      formData.append("contract_expiry", contractExpiryDate.format("YYYY-MM-DDThh:mm:ss"));
      formData.append("company", formID.querySelector('[name="company"]').value);
      formData.append("sub_user_deal", formID.querySelector('[name="sub_user_deal"]').value);
      formData.append("national_tax_number", formID.querySelector('[name="national_tax_number"]').value);
      formData.append("business_reg_number", formID.querySelector('[name="business_reg_number"]').value);
      formData.append("street_and_number", formID.querySelector('[name="street_and_number"]').value);
      formData.append("postal_code", formID.querySelector('[name="postal_code"]').value);
      formData.append("city", formID.querySelector('[name="city"]').value);
      formData.append("country", formID.querySelector('[name="country"]').value);
      formData.append("phone", formID.querySelector('[name="phone"]').value);

      setDataModal(formData);
      setToggleModal(true);

    });
  }, [lang, opt, contractExpiryDate]);

  return (
    <div>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <h3>{t("subUsers.add.title")}</h3>
              <Form id="addNewSubUser">
                
                <div className="mt-3 mb-5">
                  <h6>{t("subUsers.add.form.label.personalDetails")}</h6>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.firstName")}</Label>
                    <Input name="first_name" type="text" className="form-control" />
                  </FormGroup>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.lastName")}</Label>
                    <Input name="last_name" type="text" className="form-control" />
                  </FormGroup>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.email")}</Label>
                    <Input name="email" type="email" className="form-control" />
                  </FormGroup>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.username")}</Label>
                    <Input name="username" type="text" className="form-control" />
                  </FormGroup>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.password")}</Label>
                    <Input name="password" type="password" className="form-control" />
                  </FormGroup>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.confirmPassword")}</Label>
                    <Input name="confirmPassword" type="password" className="form-control" />
                  </FormGroup>
                </div>

                <div className="mt-5 mb-5">
                  <h6>{t("subUsers.add.form.label.businessDetails")}</h6>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.companyName")}</Label>
                    <Input name="company" type="text" className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.contractExpiry")}</Label>
                    <Datetime
                      inputProps={{ name: "contract_expiry" }}
                      locale="en-gb"
                      timeFormat={false}
                      isValidDate={validDate}
                      value={contractExpiryDate}
                      onChange={(e) => setContractExpiryDate(e)}
                    />
                    <FormText color="muted">
                      {t("subUsers.add.form.help_text.contractExpiry", {afterOneYear: afterOneYear.format('DD/MM/YYYY')})}
                    </FormText>
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.subUserDeal")}</Label>
                    <Input name="sub_user_deal" type="number" min={0} max={100} step={0.1} className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.nationalTaxNumber")}</Label>
                    <Input name="national_tax_number" type="text" className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.businessRegistrationNumber")}</Label>
                    <Input name="business_reg_number" type="text" className="form-control" />
                  </FormGroup>
                </div>

                <div className="mt-5 mb-5">
                  <h6>{t("subUsers.add.form.label.contactDetails")}</h6>
                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.streetAndNumber")}</Label>
                    <Input name="street_and_number" type="text" className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.postalCode")}</Label>
                    <Input name="postal_code" type="text" className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.city")}</Label>
                    <Input name="city" type="text" className="form-control" />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.country")}</Label>
                    <Select
                      components={{ IndicatorSeparator:() => null }}
                      name="country"
                      options={Countries}
                      value={country}
                      onChange={e => setCountry(e)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>{t("subUsers.add.form.label.phoneNumber")}</Label>
                    <Input name="phone" type="text" className="form-control" />
                  </FormGroup>
                </div>

                <Button color="success" type="submit">
                  {t("subUsers.add.form.button.submit")}
                </Button>
              </Form>

              <div style={{ paddingTop: "24px" }}>
                {success && (
                  <Alert color="success">{t("subUsers.add.message.success")}</Alert>
                )}
                {redirect ? <Redirect to="/sub-users" /> : null}
                {errorPut && (
                  <Alert color="danger">
                    {t("subUsers.add.message.error")}
                  </Alert>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {dataModal && (
        <ModalConfirm
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          title={t("subUsers.add.modal.header")}
          setSuccess={setSuccess}
          setError={setError}
          body={t("subUsers.add.modal.body")}
          apiURL={`sub-users`}
          setRedirect={setRedirect}
        />
      )}
    </div>
  );
};

export default SubUsersAdd;